import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject, EMPTY } from 'rxjs';

@Injectable()
export class StockTransferAddProductSliderModelService {
  public addStockTransferAddProductSlider: BehaviorSubject<boolean>;
  public stockTransferAddSidenav: MatSidenav;
  private activeSliderValue: string;
  stockTransferSliderCloseRqt: Subject<boolean>;
  stockTransferAddModelData: BehaviorSubject<any>;
  public shipToOrDeliverToAccount: number;
  public shipToAccount: number;
  public isCustomerPickup: boolean;
  public newItems: any;

  constructor() {
    this.addStockTransferAddProductSlider = new BehaviorSubject(false);
    this.stockTransferAddModelData = new BehaviorSubject(EMPTY);
    this.stockTransferSliderCloseRqt = new Subject();
  }

  activeSlider(value: string) {
    this.activeSliderValue = value;

    if (value === 'AddStockTransferProductSlider') {
      this.addStockTransferAddProductSlider.next(true);
      this.stockTransferAddModelData.next(EMPTY);
      this.stockTransferAddSidenav.toggle();
    }
  }

  public setStockTransferSideNav(sideNavObj: MatSidenav) {
    this.stockTransferAddSidenav = sideNavObj;
  }

  public stockTransferClose() {
    this.stockTransferAddModelData.next(EMPTY);
    this.addStockTransferAddProductSlider.next(false);
    this.stockTransferAddSidenav.close();
  }

  public setData<T>(obj: T) {
    this.stockTransferAddModelData.next(obj);
  }

  public getNewItem() {
    return this.newItems;
  }

  public setNewItem(newItems) {
    this.newItems = [];
    this.newItems = newItems;
  }
}
